import { render, staticRenderFns } from "./ConfigTab.vue?vue&type=template&id=1298f7ce&scoped=true"
import script from "./ConfigTab.vue?vue&type=script&lang=js"
export * from "./ConfigTab.vue?vue&type=script&lang=js"
import style0 from "./ConfigTab.vue?vue&type=style&index=0&id=1298f7ce&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1298f7ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1298f7ce')) {
      api.createRecord('1298f7ce', component.options)
    } else {
      api.reload('1298f7ce', component.options)
    }
    module.hot.accept("./ConfigTab.vue?vue&type=template&id=1298f7ce&scoped=true", function () {
      api.rerender('1298f7ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderViewConfig/components/ConfigTab.vue"
export default component.exports